import styled from 'styled-components';

const Container = styled.div`
  box-sizing: border-box;
`;

export { Container };
